// extracted by mini-css-extract-plugin
export default {"titleContainer":"title_titleContainer__f1wpt","title":"title_title__SH43p","centered":"title_centered__I5is3"};